import { createSelector } from '@ngrx/store';
import { creditCardsState } from '../root';

export const getCardConnectLocationConfig = createSelector(creditCardsState, (creditCards) => creditCards.cardConnect.locationConfig);
